import { useGetVehicleInfo } from "../../../../../queries/useGetVehicleInfo";
import { createQueryStringHook } from "../../../../../stores/useQueryState";

const useParam = createQueryStringHook("size", "");

export const useTireSize: typeof useParam = () => {
  const { data: info } = useGetVehicleInfo();
  const [state, setState] = useParam(
    info?.vehicleOriginalTiresize?.vehicleSubmodelTiresizeId || ""
  );

  const fallbackState = info?.vehicleFullTireSizeInfo.some(
    ({ vehicleSubmodelTiresizeId }) => vehicleSubmodelTiresizeId === state
  )
    ? state
    : info?.defaultVehicleSubmodelTiresizeId || "";

  return [fallbackState, setState];
};
